<!--To add '&& allPrimaryHub.length>0' condition to '*ngIf'-->
<!--To add '&& allSecondaryHub.length>0' condition to '*ngIf'-->
<div class="right-panel"
     *ngIf="ownerArray.length > 0 && allPlatforms.length > 0">
  <div class="panel-header">
    <p class="panel-title"> Create a Network Server</p>
  </div>
  <div class="panel-container">
    <form name="createNS"
          class="createNS"
          #validate="ngForm"
          action="">

      <!--  Owner field-->
      <div class="createNS-row">
        <label class="widget-create-title">Owner
          <i class="fa fa-info-circle info-text"></i>
        </label>

        <div class="live-search">
          <ngx-select [allowClear]="true"
                     #select1
                     [items]="ownerArray"
                     (select)="selectedOwner($event)"
                     (remove)="removedOwner($event)">
          </ngx-select>
        </div>
      </div>

      <!--  ProtocolVersion field-->
      <div class="createNS-row">
        <label class="widget-create-title">Protocol Version
          <i class="fa fa-info-circle info-text"></i>
        </label>

        <div class="live-search">
          <ngx-select [items]="protocolVersions"
                     (select)="selectedProtocolVersion($event)">
          </ngx-select>
        </div>
      </div>

      <div class="createNS-row">
        <label for="name"
               class="widget-create-title">Name
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input id="name"
               class="widget-create-content form-control"
               [ngClass]="{'nameUsedError': nameExist}"
               [(ngModel)]="networkServerModel.name"
               name="name"
               required
               #nameInput
               maxlength="40"
               #name="ngModel"
               (input)="validateName(networkServerModel.name, nameInput)"
               (keyup)="trimValue($event)"
               autocomplete="off"/>
        <i class="fa fa-check check-input-validation" aria-hidden="true"></i>

        <!--Errors-->
        <div *ngIf="name.invalid && (name.dirty || name.touched)"
             class="alert alert-danger alert-validate">
          <div [hidden]="!name.hasError('required')">Name is required</div>
        </div>
        <div *ngIf="nameExist"
             class="alert alert-danger alert-validate">Name already exist!
        </div>

      </div>

      <div class="createNS-row" *ngIf="!networkServerModel.nsGroupId">
        <div *ngFor="let netId of networkServerModel.netIds; let i = index; trackBy: trackByFn">
          <label *ngIf="i==0"
                 class="widget-create-title">NetID
            <i class="fa fa-info-circle info-text"></i>
          </label>
          <label *ngIf="i!=0"
                 class="widget-create-title">
          </label>
          <input class="widget-create-content add-ids-input"
                 [(ngModel)]="networkServerModel.netIds[i]"
                 (change)="editNetId(i, $event)"
                 name="f{{i}}"
                 id="f{{i}}"
                 #netId="ngModel"
                 (input)="validateId(networkServerModel.netIds[i], i)"
                 autocomplete="off">
          <button class="add-row"
                  (click)="removeNetId(inputNetId.value, i)">-
          </button>

          <!--Errors-->
          <div *ngIf="trackingPattern[i]"
               class="alert alert-danger alert-validate">NetId is not valid! It should be in format [prefix]/[suffix] where prefix contains 6 hexadecimal characters and suffix is between 18-24.
          </div>
          <div *ngIf="trackingArr[i]"
               class="alert alert-danger alert-validate">Another network node with same NetID/JoinEUI already exists in the database!
          </div>
          <div *ngIf="trackingArr[i]==false && trackingPattern[i]==false && trackingCheck[i]"
               class="alert alert-danger alert-validate">You already entered this NetID!
          </div>

        </div>
        <label *ngIf="networkServerModel.netIds.length == 0"
               class="widget-create-title">NetID
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <label *ngIf="networkServerModel.netIds.length != 0"
               class="widget-create-title">
        </label>
        <input #inputNetId
               class="widget-create-content add-ids-input"
               name="netId"
               (input)="validation(inputNetId.value)"
               autocomplete="off">
        <button class="add-row"
                (click)="addNetId()">+
        </button>

        <!--Errors-->
        <div *ngIf="noValid"
             class="alert alert-danger alert-validate">NetId is not valid! It should be in format [prefix]/24 where prefix contains 6 hexadecimal characters..
        </div>
        <div *ngIf="netIdExist"
             class="alert alert-danger alert-validate">Another network node with same NetID/JoinEUI already exists in the database!
        </div>
        <div *ngIf="netIdExist==false && noValid==false && duplicatesExist"
             class="alert alert-danger alert-validate">You already entered this NetID!
        </div>
      </div>

      <div class="createNS-row">
        <label for="url_fns"
               class="widget-create-title">fNS URL
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input id="url_fns"
               #inputFns
               class="widget-create-content form-control"
               [(ngModel)]="networkServerModel.url_fns"
               (input)="validateUrl(networkServerModel.url_fns, inputFns)"
               name="url_fns"
               #url_fns="ngModel"
               autocomplete="off">
        <i class="fa fa-check check-input-validation" aria-hidden="true"></i>
        <div *ngIf="fnsPatternError"
             class="alert alert-danger alert-validate">Must be a valid URL!
        </div>
      </div>

      <div class="createNS-row">
        <label for="url_sns"
               class="widget-create-title">sNS URL
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input id="url_sns"
               #inputSns
               class="widget-create-content form-control"
               [(ngModel)]="networkServerModel.url_sns"
               name="url_sns"
               (input)="validateUrl(networkServerModel.url_sns, inputSns)"
               #url_sns="ngModel"
               autocomplete="off">
        <i class="fa fa-check check-input-validation" aria-hidden="true"></i>
        <div *ngIf="snsPatternError"
             class="alert alert-danger alert-validate">Must be a valid URL!
        </div>
      </div>

      <div class="createNS-row">
        <label for="url_hns"
               class="widget-create-title">hNS URL
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input #inputHns
               id="url_hns"
               class="widget-create-content form-control"
               [(ngModel)]="networkServerModel.url_hns"
               (input)="validateUrl(networkServerModel.url_hns, inputHns)"
               name="url_hns"
               #url_hns="ngModel"
               autocomplete="off">
        <i class="fa fa-check check-input-validation" aria-hidden="true"></i>
        <div *ngIf="hnsPatternError"
             class="alert alert-danger alert-validate">Must be a valid URL!
        </div>
      </div>

      <!--  Platform field-->
      <div class="createNS-row">
        <label class="widget-create-title">Platform
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <div class="live-search">
          <ngx-select [allowClear]="true"
                     #select2
                     [items]="allPlatforms"
                     (select)="selectedPlatform($event)"
                     (remove)="removedPlatform($event)">
          </ngx-select>
        </div>
      </div>

      <!--  NSGroup field-->
      <div class="createNS-row" *ngIf="renderNsGroup && allNsGroups.length && doNotHaveNetId">
        <label class="widget-create-title">NS Group
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <div class="live-search">
          <ngx-select [allowClear]="true"
                     #select3
                     [items]="allNsGroups"
                     (select)="selectedNsGroup($event)"
                     (remove)="removedNsGroup($event)">
          </ngx-select>
        </div>
      </div>

      <div class="createNS-row" *ngIf="renderNsGroup">
        <label for="subnwkId"
               class="widget-create-title">Subnetwork ID
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input id="subnwkId"
               #inputCheckSubnwkId
               class="widget-create-content form-control"
               [(ngModel)]="networkServerModel.subnwkId"
               name="subnwkId"
               maxlength="40"
               (input)="validateSubnwkId(inputCheckSubnwkId.value, inputCheckSubnwkId, $event)"
               (change)="validateSubnwkId(inputCheckSubnwkId.value, inputCheckSubnwkId, $event)"
               autocomplete="off">

        <!--Errors-->
        <div *ngIf="noValidSubnwkId"
             class="alert alert-danger alert-validate">SubnetworkId is not valid! It should be in the format of &lt;32-bit hex&gt;/&lt;prefix len&gt;, eg. 12ABC000/20
        </div>
        <div *ngIf="subnwkIdOutOfRange"
             class="alert alert-danger alert-validate">DevAddr range is outside the address space of the selected NS Group's NetID.
        </div>
        <div *ngIf="subnwkIdExist"
             class="alert alert-danger alert-validate">Another network node with overlapping SubnetworkID already exists in the database!
        </div>
      </div>

      <!--  NS ID field -->
      <div class="createNS-row" *ngIf="networkServerModel.protocolVersion != '1.0'">
        <label for="ns_id"
               class="widget-create-title">NS ID
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input id="ns_id"
               class="widget-create-content form-control"
               [ngClass]="{'nsIdUsedError': nsIdExist}"
               [(ngModel)]="networkServerModel.nsId"
               name="ns_id"
               #inputNsId
               (input)="validateNsId(networkServerModel.nsId, inputNsId)"
               (keyup)="trimValue($event)"
               autocomplete="off"/>
        <i class="fa fa-check check-input-validation" aria-hidden="true"></i>

        <!--Errors-->
        <div *ngIf="noValidNsId"
             class="alert alert-danger alert-validate">NsId is not valid! It should contain 16 hexadecimal characters..
        </div>
        <div *ngIf="nsIdExist"
             class="alert alert-danger alert-validate">Another network server with same NSID already exists in the database!
        </div>
      </div>

      <!--SubscriberID field -->
      <div class="createNS-row" *ngIf="networkServerModel.protocolVersion != '1.0'">
        <label for="subscriber_id"
               class="widget-create-title">Subscriber ID
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input id="subscriber_id"
               #inputFns
               class="widget-create-content form-control"
               [(ngModel)]="networkServerModel.subscriberId"
               name="subscriber_id"
               #inputSubscriberId
               autocomplete="off"
               max="80" size="80">
        <i class="fa fa-check check-input-validation" aria-hidden="true"></i>
      </div>

      <!--Auth Type field-->
      <div class="createNS-row">
        <label class="widget-create-title">HTTP Auth Type
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <div class="live-search">
          <ngx-select [items]="authTypes"
                     (select)="selectedAuthType($event)">
          </ngx-select>
        </div>
      </div>

      <div class="createNS-row" *ngIf="networkServerModel.authType == 'BasicAuth'">
        <label for="authUsername"
               class="widget-create-title">Auth Username
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input id="authUsername"
               class="widget-create-content form-control"
               [(ngModel)]="networkServerModel.authUsername"
               name="authUsername"
               maxlength="20"
               autocomplete="off">
      </div>

      <div class="createNS-row" *ngIf="networkServerModel.authType == 'BasicAuth'">
        <label for="authPassword"
               class="widget-create-title">Auth Password
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input id="authPassword"
               class="widget-create-content form-control"
               [(ngModel)]="networkServerModel.authPassword"
               name="authPassword"
               maxlength="20"
               autocomplete="off">
      </div>

      <!-- Security field-->
      <div class="createNS-row">
        <label class="widget-create-title">Transport Security
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <div class="live-search">
          <ngx-select [items]="securityOptions"
                     (select)="selectedSecurity($event)">
          </ngx-select>
        </div>
      </div>

      <div class="createNS-row">
        <label class="widget-create-title">Additional Accounting
          <i class="fa fa-info-circle info-text"></i>
        </label>
        <input class="checkbox-checked"
               type="checkbox"
               [(ngModel)]="networkServerModel.heliumMember"
               name="heliumMember">Helium-Style
      </div>

      <div class="panel-container">
        <div class="panel-header">
          <p class="panel-title">Add RF Param Set Element</p>
          <button class="add-row"
                  (click)="showAddRFParamSetPanel()">+
          </button>
        </div>
        <div class="panel-container" *ngIf="!rfParamSetPanelHidden">
          <form name="addRfParamSetElement"
            class="createNS"
            #validate="ngForm"
            action="">

            <div class="createNS-row">
              <label for="paramSetId" class="widget-create-title">Param Set ID
                <i class="fa fa-info-circle info-text"></i>
              </label>
              <textarea id="paramSetId"
                   size="128"
                   class="widget-create-content form-control"
                   [ngClass]="{'paramSetIdUsedError': paramSetIdExist}"
                   [(ngModel)]="rfParamSetElement.RFParamSetID"
                   name="paramSetId"
                   rows="3"
                   required
                   #paramSetIdInput
                   maxlength="128"
                   #paramSetId="ngModel"
                   (input)="validateParamSetId(rfParamSetElement.RFParamSetID, paramSetIdInput)"
                   (keyup)="trimValue($event)"
                   autocomplete="off"></textarea>
              <i class="fa fa-check check-input-validation" aria-hidden="true"></i>

              <!--Errors-->
              <div *ngIf="paramSetId.invalid && (paramSetId.dirty || paramSetId.touched)"
                class="alert alert-danger alert-validate">
                <div [hidden]="!paramSetId.hasError('required')">Param Set ID is required</div>
              </div>

              <div *ngIf="paramSetIdExist"
                class="alert alert-danger alert-validate">Param Set ID already exists!
              </div>
            </div>

            <div class="createNS-row">
              <label for="actilityRfParamSet" class="widget-create-title">Actility RF ParamSet
                <i class="fa fa-info-circle info-text"></i>
              </label>
              <input type="file" (change)="fileChangeEvent($event)"
                class="widget-create-content form-control" name="actilityRfParamSet"
                required
                #actilityRfParamSetInput
                name="actilityRfParamSet"/>
                <i class="fa fa-check check-input-validation" aria-hidden="true"></i>
            </div>

            <div class="btn-area">
              <button type="cancel" (click)="cancelAddRFParamSetElement()"
                class="custom-btn">Cancel
              </button>
              <button type="submit"
                    class="custom-btn create-btn form-control"
                    [disabled]="!rfParamSetElement.isValid()"
                    (click)="addRFParamSetElement()">Add
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- RF PARAMSET ELEMENTS -->
      <div id="getRFParamSetElements" class="table-header margin-top-30" *ngIf="rfParamSets.length!=0">
        <span>RF ParamSet Elements</span>
        <div class="table-panel">
          <table class="table-roaming-partners table table-striped table-responsive"
           id="rfParamSet-elements-list">
            <thead>
            <tr>
            <th>RFParamSetID</th>
            <th>RFParamSetTimestamp</th>
            <th>ActilityRFParamSet</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of rfParamSets">
              <td>{{item.RFParamSetID}}</td>
              <td>{{item.RFParamSetTimestamp | date:'medium'}}</td>
              <td>{{item.ActilityRFParamSet | slice:0:500}}...</td>
              <td>
                <button class="add-row"
                  (click)="removeRFParamSetElement(item)">-
                </button>
              </td>
            </tr>
          </tbody>
          </table>
        </div>
      </div>


      <!-- Alarm threshold field-->
      <!--<div class="createNS-row">-->
        <!--<label class="widget-create-title">Alarm threshold-->
          <!--<i class="fa fa-info-circle info-text"></i>-->
        <!--</label>-->
        <!--<input class="widget-create-content form-control"-->
               <!--[(ngModel)]="networkServerModel.alarm"-->
               <!--name="alarm"-->
               <!--#alarmInput-->
               <!--#alarm="ngModel"-->
               <!--maxlength="7"-->
               <!--(input)="validateAlarm(networkServerModel.alarm, alarmInput)"
               autocomplete="off">-->
        <!--<i class="fa fa-check check-input-validation" aria-hidden="true"></i>-->
        <!--<div *ngIf="errorValidAlarm"-->
             <!--class="alert alert-danger alert-validate">Alarm is required.-->
        <!--</div>-->
        <!--<div *ngIf="errorPatternAlarm"-->
             <!--class="alert alert-danger alert-validate">Alarm is invalid.-->
        <!--</div>-->
      <!--</div>-->


      <!--Security method field-->
      <!--<div class="createNS-row">-->
        <!--<label for="security"-->
               <!--class="widget-create-title">Security method-->
          <!--<i class="fa fa-info-circle info-text"></i>-->
        <!--</label>-->
        <!--<select id="security"-->
                <!--class="widget-create-content"-->
                <!--[(ngModel)]="networkServerModel.security"-->
                <!--name="security">-->
          <!--<option>{{networkServerModel.security}}</option>-->
        <!--</select>-->
      <!--</div>-->



      <div class="btn-area">
        <button class="custom-btn"
                (click)="backClicked()">Cancel
        </button>
        <button type="submit"
                class="custom-btn create-btn form-control"
                [disabled]="urlPatternError
                || disableName
                || hasError
                || nameExist
                || duplicatesExist
                || noValid
                || noValidNsId
                || (noValidSubnwkId && renderNsGroup)
                || (subnwkIdOutOfRange && renderNsGroup)
                || (subnwkIdExist && renderNsGroup)
                || (doNotHaveNetId && !renderNsGroup)
                || (doNotHaveSubnwkId && renderNsGroup)
                || disableSaveButton
                || netIdExist
                || nsIdExist
                || patternError
                || !haveUrl
                || !platformExists
                || !authTypeExists
                || !securityExists
                || !protocolVersionExists
                "
                (click)="addNetId();saveNetworkServer()">Save
        </button>
      </div>

    </form>
  </div>

</div>
